import script from "./PageThemeEditorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PageThemeEditorLayout.vue?vue&type=script&setup=true&lang=js"

import "./PageThemeEditorLayout.vue?vue&type=style&index=0&id=2db6384f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db6384f"]])

export default __exports__